import { ReactNode } from 'react';

export enum WallpaperCategory {
  CUSTOM = 'custom',
  CURATED = 'curated',
  BRANDED = 'branded',
}

export interface TransferCustomizationProviderProps {
  children?: ReactNode;
}
